import { ContextMenu, Dropdown, IconButton, Input, LeftSideList, MenuItem, MenuList, PluginContextType, SideHeader, TnModal, DataRow } from 'bimui';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as AddSvg } from 'bimui/dist/c1/icons/create.svg';
import { BaseUtils } from 'tnbase';
import classNames from 'classnames';
import { message } from 'antd';
import './index.less';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import { emitter } from '@/utils/mitt';
import { CmdContext, EngineContext } from '@/App';
import { AxesPrimitive, DataChangeStruct, PythaEngineControl, PythaEventDataChange, PythaEventName, PythaEventSetting, SETTING_KEY } from 'pytha2'
import { createAxes, createAxesMulti, deleteAxes, findAxesListInGraphic } from '@/declare/api/geometry/axes';
import { useParams } from 'react-router-dom';
import localStore from '@/store/local-store';
import { TOOL_TYPE } from '@/declare/enums/menu-type';


/**
 * UCS
 */
export default function UcsPanel() {
    const { engine } = useContext(EngineContext);
    const { projectUuid } = useParams();

    const [dataList, setDataList] = useState<AxesPrimitive[]>([]);  // ucs列表

    const [activeUCS, setActiveUCS] = useState<string>(null);   //置为当前的坐标系

    const [selectedDataUuids, setSelectedDataUuids] = useState<string[]>([]);  // 选中的数据uuid
    const [editUuid, setEditUuid] = useState<string>(null);  // 编辑的uuid
    const [inputValue, setInputValue] = useState<string>('');  // 输入框值

    const [ctxVisible, setCtxVisible] = useState<boolean>(false);   //右键菜单是否显示
    const [ctxUuid, setCtxUuid] = useState<string>(null);   //右键菜单的uuid
    const [ctxLeft, setCtxLeft] = useState<number>(0);   //菜单left
    const [ctxTop, setCtxTop] = useState<number>(0);   //菜单top
    const isDbClickRef = useRef<boolean>(false);  // 是否双击
    const lastClickIdxRef = useRef<number>(null);  // 上一次点击的索引，用于进行Shift键区间选择操作

    const { updateCmdInputValue } = useContext(CmdContext);

    /**
     * 通用工具区激活的编辑信号
     */
    const [editFlag, setEditFlag] = useState<string>();
    /**
     * 通用工具区激活的删除信号
     */
    const [deleteFlag, setDeleteFlag] = useState<string>();
    /**
     * 监听通用工具区编辑和删除信号
     */
    useEffect(() => {
        emitter.on(Emit_Event_Common_Tool.DELETE, () => setDeleteFlag(BaseUtils.genUUID()));
        emitter.on(Emit_Event_Common_Tool.EDIT, () => setEditFlag(BaseUtils.genUUID()));

        return () => {
            emitter.off(Emit_Event_Common_Tool.DELETE, () => setDeleteFlag(BaseUtils.genUUID()));
            emitter.off(Emit_Event_Common_Tool.EDIT, () => setEditFlag(BaseUtils.genUUID()));
        };
    }, [])
    /**
     * 监听到编辑信号调用编辑方法
     */
    useEffect(() => {
        if (!selectedDataUuids || selectedDataUuids.length === 0) return;
        if (selectedDataUuids.length !== 1) return;
        onClickEdit();
    }, [editFlag])
    /**
     * 监听到编辑信号调用删除方法
     */
    useEffect(() => {
        if (!selectedDataUuids || selectedDataUuids.length === 0) return;
        // 调用外部回调，执行删除操作,并更新树节点
        onClickDelete();
    }, [deleteFlag])

    /**
     * 打开时获取localStore中储存的属性
     */
    useEffect(() => {
        let status = localStore.getToolPanelStatus(TOOL_TYPE.UCS);
        setSelectedDataUuids(status?.selectedUcs || []);
        setActiveUCS(status?.activeUCS);
    }, [])

    /**
     * 将选中的内容存入localStore中
     */
    useEffect(() => {
        updateStatus(selectedDataUuids, activeUCS);
    }, [selectedDataUuids, activeUCS])
    /**
     * 存入localStore中的方法
     */
    const updateStatus = (data, active) => {
        // 在这里向外传递状态
        let status = {
            selectedUcs: data,
            activeUCS: active,
        };
        localStore.setToolPanelStatus(TOOL_TYPE.UCS, status);
    }

    const activeUcsRef = useRef<string>('');
    const axesListRef = useRef<AxesPrimitive[]>([]); // 坐标系列表
    const [isInit, setIsInit] = useState<boolean>(false);

    useEffect(() => {
        axesListRef.current = dataList;
    }, [dataList])

    useEffect(() => {
        activeUcsRef.current = activeUCS;
    }, [activeUCS])

    /**
     * 初始化获取坐标轴列表
     * @param engine 
     * @returns 
     */
    useEffect(() => {
        if (isInit || !engine) return;
        initAxes(engine);
    }, [engine, isInit])

    /**
     * 初始化获取坐标轴
     * @param engine 
     * @returns 
     */
    const initAxes = (engine: PythaEngineControl) => {
        return new Promise((resolve, reject) => {
            findAxesListInGraphic(projectUuid).then(res => {
                const jsonList: any[] = res.data || [];
                const axesList = [];
                for (const json of jsonList) {
                    const axes = new AxesPrimitive();
                    axes.fromJson(json.properties);
                    axesList.push(axes);
                }
                const wcsIndex = axesList.findIndex(axes => axes.isWcs);
                // 从原数组删除，再加到头部
                if (wcsIndex > 0) {
                    const wcs = axesList.splice(wcsIndex, 1)[0];
                    axesList.unshift(wcs);
                }
                setDataList(axesList);
                setIsInit(true);
            })
            resolve(1);
        })
    }

    /**
     * 监听engine
     * @param engine 
     * @returns 
     */
    useEffect(() => {
        if (!engine) return;
        // 监听引擎事件并显示通知
        engine.eventMediator.noticeHandler?.onNotice?.subscribe((sender, event) => {
            if (event.cmd === PythaEventName.DATA_CHANGE) {
                let data = event?.data as DataChangeStruct;
                if (!data) return;
                const axesList = [...axesListRef.current];
                if (data.add_axes) {
                    setActiveUCS(engine.storage.primitiveStore.axes.uuid);
                    for (const axes of data.add_axes) {
                        axesList.push(axes);
                    }
                    setDataList([...axesList]);
                }
                if (data.delete_axes) {
                    axesList.filter(axes => data.delete_axes.uuid !== axes.uuid);
                    if (activeUcsRef.current === data.delete_axes.uuid) {
                        setActiveUCS(engine.storage.primitiveStore.axes.uuid);
                    }
                    setDataList([...axesList]);
                }
            }
        });

        return () => {
        };
    }, [engine]);


    /**
     * 点击数据行的执行逻辑（操作为单选，shift键做区间选择，ctrl键做多选）
     * @param e 
     * @param item 
     * @param index 
     */
    const onClickData = (e, item, index) => {
        isDbClickRef.current = false;
        setTimeout(() => {
            if (isDbClickRef.current) return;
            const isCtrl = e.ctrlKey;
            const isShift = e.shiftKey;
            let uuids = [...selectedDataUuids];
            const idx = uuids.findIndex(uuid => uuid === item.uuid);
            if (isCtrl) {
                if (idx !== -1) {
                    uuids.splice(idx, 1);
                } else {
                    uuids.push(item.uuid);
                }
            } else if (isShift && lastClickIdxRef.current != null && lastClickIdxRef.current >= 0) {
                const start = Math.max(0, Math.min(index, lastClickIdxRef.current));
                const end = Math.min(dataList.length - 1, Math.max(index, lastClickIdxRef.current));

                for (let i = start; i <= end; i++) {
                    const com = dataList[i];
                    if (!uuids.includes(com.uuid)) {
                        uuids.push(com.uuid);
                    }
                }
            } else {
                if (idx !== -1) {
                    uuids = [];
                } else {
                    uuids = [item.uuid];
                }
            }
            lastClickIdxRef.current = index;
            setSelectedDataUuids([...uuids])
        }, 150)
    }

    /**
     * 右键数据行的执行逻辑
     * @param e 
     * @param item 
     */
    const onContextData = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        setCtxUuid(item.uuid);
        setCtxVisible(true);
        setCtxLeft(e.clientX);
        setCtxTop(e.clientY);
        if (!selectedDataUuids.includes(item.uuid)) {
            // setSelectedDataUuids([...selectedDataUuids, item.uuid]); //默认将右键对象添加到选中列表
            setSelectedDataUuids([item.uuid]); //当右键对象不再当前选中列表，清空列表仅保留右键对象
        }
    }

    /**
     * 设置当前选中的 UCS 为活动 UCS
     */
    const setCurrentUcs = () => {
        setCtxVisible(false);
        if (!setSelectedDataUuids) return;
        let selectUuid = selectedDataUuids[0];
        const axes = dataList.find(a => a.uuid === selectUuid);
        if (!axes || selectUuid === activeUCS) return;
        setActiveUCS(axes.uuid);
        let pythaEvent = new PythaEventSetting();
        pythaEvent.data = { key: SETTING_KEY.AXES, value: axes }
        engine.eventMediator?.emitEvent(pythaEvent);
    };

    /**
     * 激活重命名编辑状态
     */
    const onClickEdit = () => {
        setCtxVisible(false);
        const dataRow = dataList.find(item => item.uuid === ctxUuid);
        if (dataRow == null) {
            message.warning("请先选择UCS");
            return;
        }
        updateCmdInputValue(true);
        setInputValue(dataRow.name);
        setEditUuid(ctxUuid);
    }
    /**
     * 重命名数据行
     */
    const onDataBlur = () => {
        if (inputValue == null || inputValue == '') {
            message.warning("名称不能为空");
            return;
        }
        // 检查是否与其他坐标系重名
        const isDuplicate = dataList.some(item => item.name === inputValue && item.uuid !== editUuid);
        if (isDuplicate) {
            message.warning(`名称 "${inputValue}" 已存在`);
            return;
        }

        setEditUuid(null);
        const dataIdx = dataList.findIndex(item => item.uuid === editUuid);
        if (dataIdx === -1) {
            return;
        }
        const data = dataList[dataIdx];
        if (data.name === inputValue) return;
        data.name = inputValue;
        createAxes(projectUuid, data.toJson()).then(res => {
            setDataList([...dataList]);
        }).catch(err => {
            message.error(`重命名失败`);
        }).finally(() => {
            updateCmdInputValue(false);
            setInputValue(null);
        })
    }
    /**
     * 点击新增数据行
     */
    const onClickAddData = () => {
        if (engine) {
            engine.eventMediator.emitEvent({
                cmd: 'CMD',
                data: "UCS",
            });
        } else {
            message.error("引擎未初始化");
        }
    }


    // 删除坐标系
    const onClickDelete = () => {

        setCtxVisible(false);

        if (!selectedDataUuids || selectedDataUuids.length === 0) {
            message.error("请选择一个或多个 UCS 进行删除");
            return;
        }
        // 过滤掉无法删除的 WCS
        const deletableUuids = selectedDataUuids.filter(uuid => {
            const ucs = dataList.find(item => item.uuid === uuid);
            if (ucs?.isWcs) {
                message.warning(`世界坐标系无法删除`);
                return false;
            }
            return true;
        });

        if (deletableUuids.length === 0) {
            return;
        }

        TnModal().deleteModal({
            onOk: () => {
                Promise.all(deletableUuids.map(uuid => deleteAxes(uuid)))
                    .then(() => {
                        // 更新 dataList，移除已删除的坐标系
                        const updatedDataList = dataList.filter(item => !deletableUuids.includes(item.uuid));
                        setDataList(updatedDataList);

                        // 如果删除的坐标系中包含当前活动 UCS，切换到默认 WCS
                        if (deletableUuids.includes(activeUCS)) {
                            const wcs = updatedDataList.find(item => item.isWcs);
                            if (wcs) {
                                setActiveUCS(wcs.uuid);
                                let pythaEvent = new PythaEventSetting();
                                pythaEvent.data = { key: SETTING_KEY.AXES, value: wcs };
                                engine.eventMediator?.emitEvent(pythaEvent);
                            }
                        }
                    })
                    .catch(err => {
                        message.error("删除失败");
                    })
                    .finally(() => {
                        // 清空选中状态
                        setSelectedDataUuids([]);
                        TnModal().destoryAll();
                    });
            }
        })
    }

    /**
     * 获取当前激活的 UCS
     */
    useEffect(() => {
        const status = localStore.getToolPanelStatus(TOOL_TYPE.UCS);
        const active = status?.activeUCS

        // 优化判断逻辑
        if (dataList.length > 0) {
            const activeAxes = dataList.find(item => item.uuid === active);
            if (activeAxes) {
                setActiveUCS(active); // 设置当前激活的 UCS
                const pythaEvent = new PythaEventSetting();
                pythaEvent.data = { key: SETTING_KEY.AXES, value: activeAxes };
                engine.eventMediator?.emitEvent(pythaEvent);
            } else if (!activeUCS || !dataList.some(item => item.uuid === activeUCS)) {
                setActiveUCS(dataList[0].uuid); // 设置默认值
            }
        }

    }, [dataList]);


    return (
        <div className="ucs-side-bar">
            <SideHeader>
                <div className="ucs-header">
                    <span>UCS</span>
                    <IconButton icon={<AddSvg />} onClick={onClickAddData} />
                </div>
            </SideHeader>

            <div className="data-list">
                {dataList.map((data, index) => {
                    const isActive = data.uuid === activeUCS;

                    return (
                        <DataRow
                            key={data.uuid}
                            data={data}
                            index={index}
                            editUuid={editUuid}
                            inputValue={inputValue}
                            setInputValue={setInputValue}
                            onDataBlur={onDataBlur}
                            onClickData={onClickData}
                            onContextData={onContextData}
                            selectedDataUuids={selectedDataUuids}
                            active={isActive} // 确保第一行 active 为 true
                            onActivate={(uuid) => {
                                if (uuid === activeUCS) return;
                                setActiveUCS(uuid); // 更新当前激活的UCS
                                // 调用坐标轴切换逻辑
                                const axes = dataList.find((item) => item.uuid === uuid);
                                if (axes) {
                                    let pythaEvent = new PythaEventSetting();
                                    pythaEvent.data = { key: SETTING_KEY.AXES, value: axes };
                                    engine?.eventMediator?.emitEvent(pythaEvent);
                                }
                            }}
                        />
                    );
                })}
            </div>

            <ContextMenu visible={ctxVisible} left={ctxLeft} top={ctxTop} onCancel={() => setCtxVisible(false)}>
                <MenuList>
                    <MenuItem onClick={setCurrentUcs} disabled={selectedDataUuids.length !== 1}>置为当前</MenuItem>
                    <MenuItem onClick={onClickEdit} disabled={selectedDataUuids.length !== 1}>重命名</MenuItem>
                    <MenuItem special onClick={onClickDelete}>删除</MenuItem>
                </MenuList>
            </ContextMenu>
        </div>
    )
}